import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon57: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M7 0C10.865 0 14 3.134 14 7C14 8.099 13.746 9.138 13.295 10.064L19.33 16.099C20.223 16.991 20.223 18.439 19.331 19.33C18.438 20.223 16.991 20.223 16.1 19.33L10.063 13.296C9.13799 13.747 8.098 14 7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0ZM10.957 12.775L16.807 18.624C17.308 19.125 18.121 19.125 18.624 18.623C19.125 18.122 19.125 17.308 18.623 16.807L12.774 10.958C12.285 11.67 11.668 12.286 10.957 12.775ZM7 1C3.686 1 1 3.686 1 7C1 10.314 3.686 13 7 13C10.313 13 13 10.314 13 7C13 3.686 10.313 1 7 1Z"
        fill="#404040"
      />
    </Icon>
  )
}
